<template>
  <div class="flex flex-col md:flex-row w-full justify-between">
    <label
      class="md:w-1/3 title-2 whitespace-normal overflow-visible text-left text-fire text-4xl sm:text-5xl tracking-tight whitespace-nowrap"
      for="selection"
    >
      {{ label }}
    </label>
    <div class="md:my-auto relative ml-0 mt-1 md:ml-6 md:mt-1 md:w-2/3">
      <select
        class="block appearance-none w-full bg-gray-300 border border-gray-100 text-gray-700 py-3 px-4 pr-8 rounded leading-tight focus:outline-none focus:shadow-outline focus:bg-white focus:border-gray-500"
        id="selection"
        :value="value"
        @input="$emit('input', $event.target.value)"
      >
        <option value=""></option>
        <slot></slot>
      </select>
      <div
        class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700"
      >
        <svg
          class="fill-current h-4 w-4"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"
          />
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReportSelector',
  props: {
    value: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>
